export const FACT_SHEET_TABLE_PAGE_SIZE = 15;

export const getPageCount = (totalItems: number, pageSize: number = FACT_SHEET_TABLE_PAGE_SIZE): number => {
    if (!totalItems || totalItems <= 0) return 0;
    return Math.ceil(totalItems / pageSize);
};

export const getPageSlice = <T>(rows: T[], offset: number, pageSize: number = FACT_SHEET_TABLE_PAGE_SIZE): T[] => {
    if (!rows || rows.length === 0) return [];
    return rows.slice(offset, offset + pageSize);
};
